import React from 'react'
import { X, Users } from 'lucide-react'
import { Button } from '@/components/ui/button'

interface ChatBoxHeaderProps {
  participantNames: string
  messageCount: number
  onClose: () => void
}

const ChatBoxHeader: React.FC<ChatBoxHeaderProps> = ({
  participantNames,
  messageCount,
  onClose,
}) => {
  return (
    <div className='flex items-center justify-between p-4 border-b border-gray-100 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-t-xl'>
      <div className='flex items-center gap-3'>
        <div className='p-1.5 bg-slate-200 rounded-full'>
          <Users className='w-4 h-4 text-blue-600' />
        </div>
        <div>
          <span className='text-sm font-semibold text-gray-800 block'>
            {participantNames}
          </span>
          <span className='text-xs text-gray-500'>
            {messageCount} message{messageCount !== 1 ? 's' : ''}
          </span>
        </div>
      </div>
      <div className='flex items-center gap-2'>
        <Button
          onClick={onClose}
          variant='ghost'
          size='sm'
          className='h-8 w-8 p-0 hover:bg-white/60 rounded-full transition-colors'
        >
          <X className='w-4 h-4 text-gray-600' />
        </Button>
      </div>
    </div>
  )
}

export default ChatBoxHeader
